import Http from "@/api/http";

export default {
  // token查询
  findByToken: params => {
    return Http.GET("/sysUser/findByToken", null, null, params);
  },
  // 修改密码
  changePwd: params => {
    return Http.GET("/sysUser/changePwd", params);
  },
  // 修改密码
  changePwdByToken: params => {
    return Http.GET("/sysUser/changePwdByToken", params);
  },
  // 查询全部字典数据
  sysCodeTypeFindAll: params => {
    return Http.POST("/sysCodeType/findAll", null, null, params);
  },
  // 根据code 查数据字典明细
  sysCodeTypeFindByCode: params => {
    return Http.POST("/sysCodeType/findByCode", null, null, params);
  },
  // 城市信息
  getAllCity: params => {
    return Http.POST("/sysRegion/findByGrade", params);
  },
  // 文件上传
  fileUpload: params => {
    return Http.Upload("/upload/uploadFiles", params);
  },
  // 文件上传
  uploadLocalFiles: params => {
    return Http.Upload("/upload/uploadLocalFiles", params);
  },
  // 学校分页查询
  schoolFindByPage: params => {
    return Http.POST("/schoolBasic/findByPage", params);
  },
  /* 年级 列表 */
  gradeClassPage: params => {
    return Http.POST("/gradeClass/findByPage", params);
  },
};
